import { FC } from 'react';

export const Music: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M9 18V6.3554C9 5.87386 9 5.63309 9.0876 5.43781C9.16482 5.26568 9.28917 5.1189 9.44627 5.01443C9.62449 4.89591 9.86198 4.85633 10.337 4.77717L19.137 3.3105C19.7779 3.20367 20.0984 3.15026 20.3482 3.24303C20.5674 3.32444 20.7511 3.48008 20.8674 3.68289C21 3.91401 21 4.23892 21 4.88873V16M9 18C9 19.6568 7.65685 21 6 21C4.34315 21 3 19.6568 3 18C3 16.3431 4.34315 15 6 15C7.65685 15 9 16.3431 9 18ZM21 16C21 17.6568 19.6569 19 18 19C16.3431 19 15 17.6568 15 16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16Z"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
